import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Flex from '@/components/common/Flex';
import NewFeatureDot from '@/components/common/NewFeatureDot';
import SubtleBadge from '@/components/common/SubtleBadge';
import { cloneElement, isValidElement, memo, type ReactElement, type ReactNode } from 'react';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

type NavbarRoute = {
  name: string;
  to?: string;
  icon?: IconProp | ReactNode;
  badge?: { type: string; text: string };
  showNewIndicator?: boolean;
};

type NavbarVerticalMenuItemProps = {
  route: NavbarRoute;
  iconActive?: boolean;
};

const NavbarVerticalMenuItem = ({
  route,
  iconActive
}: NavbarVerticalMenuItemProps) => {
  const icon = isValidElement(route.icon)
    ? cloneElement(route.icon as ReactElement<{ active?: boolean; size?: number }>, {
        active: iconActive,
        size: 20
      })
    : route.icon;

  return (
    <Flex alignItems="center" className="w-100 min-w-0">
      {icon ? (
        <span className="nav-link-icon flex-shrink-0">
          {isValidElement(icon) ? (
            icon
          ) : (
            <FontAwesomeIcon icon={icon as IconProp} />
          )}
        </span>
      ) : null}
      <span
        className={classNames('nav-link-text ps-1 text-truncate min-w-0', {
          'fw-normal': route.to?.startsWith('/chat/c/')
        })}
      >
        {route.name}
      </span>
      {route.showNewIndicator && <NewFeatureDot className="ms-2" />}
      {route.badge && (
        <SubtleBadge pill bg={route.badge.type} className="ms-2 flex-shrink-0">
          {route.badge.text}
        </SubtleBadge>
      )}
    </Flex>
  );
};

export default memo(NavbarVerticalMenuItem);
